import ninjaApi from 'store/redux/apis/ninja.api';

export const pixelApi = ninjaApi.injectEndpoints({
  tagTypes: ['Pixel', 'Conversions', 'NetworkAccount'],
  overrideExisting: true,
  endpoints: (build) => ({
    pixels: build.query({
      query: (body) => ({
        url: '/network/pixel/get-pixels',
        method: 'POST',
        body,
      }),
    }),

    /** Create meta pixel */
    createPixel: build.mutation({
      query: (body) => ({
        url: '/network/pixel/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Pixel', 'Conversions', 'NetworkAccount'],
    }),

    /** Sync meta pixels */
    syncFacebookPixels: build.mutation({
      query: (body) => ({
        url: '/network/pixel/sync',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FacebookPixel', 'Conversions', 'NetworkAccount'],
    }),

    pages: build.query({
      query: (body) => ({
        url: '/network/page/get-pages',
        method: 'POST',
        body,
      }),
    }),

    // search pixels
    searchPixel: build.query({
      query: (body) => ({
        url: '/network/pixel/search',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  usePixelsQuery,
  usePagesQuery,
  useSearchPixelQuery,
  useCreatePixelMutation,
  useSyncFacebookPixelsMutation,
} = pixelApi;
